import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const InsiderCard: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--insider-card')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g fill="#000" fillRule="evenodd">
      <path d="M4 18V7h17v11H4zm1-1h15V8H5v9z" fillRule="nonzero" />
      <path d="M6 9.5h4v1H6z" />
    </g>
  </svg>
);

export default InsiderCard;
